import { AnimatePresence } from 'framer-motion'
import { createContext, useState } from 'react'
import SnackBar from '../components/Feedback/SnackBar'

export const SnackBarContext = createContext<any>({})
const AUTO_DISMISS = 3000
var _x

/**
 * Context creado para mostrar toast dentro de la aplicación.
 */
export function SnackBarProvider({ children }) {
  const [alert, setAlert] = useState<SnackBarProps | null>(null)
  // const [timer, setTimer] = useState<any>(null);

  const addAlert = (alert: SnackBarProps) => {
    if (alert) {
      clearTimeout(_x)
      setAlert(null)
    }
    _x = setTimeout(() => {
      setAlert(null)
    }, alert.duration || AUTO_DISMISS)
    setAlert(alert)
  }

  const value = { addAlert }

  return (
    <SnackBarContext.Provider value={value as unknown as SnackBarProps}>
      {children}
      <AnimatePresence initial={false}>
        {alert && (
          <SnackBar message={alert.message} status={alert.status}></SnackBar>
        )}
      </AnimatePresence>
    </SnackBarContext.Provider>
  )
}

interface SnackBarProps {
  message: string
  status?: 'success' | 'error' | 'warning' | 'info' | 'default' | 'loading'
  duration?: number
}
